/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHOpenIcon24Solid = forwardRef('ArrowCollapseCHOpenIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.21 14.828a4 4 0 0 1 0-5.657l5.23-5.23a1.5 1.5 0 0 1 2.12 2.122l-5.23 5.23a1 1 0 0 0 0 1.414l5.23 5.23a1.5 1.5 0 0 1-2.12 2.121l-5.23-5.23Z" }),
        React.createElement("path", { d: "M21.79 14.828a4 4 0 0 0 0-5.657l-5.23-5.23a1.5 1.5 0 1 0-2.12 2.122l5.23 5.23a1 1 0 0 1 0 1.414l-5.23 5.23a1.5 1.5 0 1 0 2.12 2.121l5.23-5.23Z" })));
});
